// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3mpnU","inputWrap":"CustomTip_inputWrap__2jN7u"};